module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"engineeringLoadingError":"Error loading menus. Please, try it later.","periodEngineeringProfitabilityError":"Error loading menus profitability data. Please, try it later."},"es":{"engineeringLoadingError":"Error cargando datos de rentabilidad de menús","periodEngineeringProfitabilityError":"Error cargando datos de rentabilidad de menús. Inténtelo de nuevo más tarde."}}')
  delete Component.options._Ctor
}
